import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const brandListStyle = StyleSheet.create({
    /**
     * 14.9 - web brand card geometry.
     *
     * Applied behind a Platform check at the call site, so the native card
     * is untouched. Three things make the cards uneven on web:
     *
     *  1. the card body is `flexWrap: "wrap"`, so a long brand name pushes
     *     the edit/delete cluster onto a second line and that one card
     *     becomes taller than its neighbour in the same row;
     *  2. the info column is a hard `width: "70%"` of a row that also holds
     *     a checkbox, so the action cluster sits at a different x on every
     *     card depending on whether the checkbox is rendered;
     *  3. the cards in a row are not stretched to a common height.
     *
     * Together these are the "uneven content distribution" in the
     * screenshot. Fixing them in the layout - rather than by padding
     * individual cards - is what keeps a row aligned whatever the brand
     * names are.
     */
    webBrandRow: {
        alignItems: 'stretch' as const,
    },
    webBrandCardCell: {
        alignSelf: 'stretch' as const,
    },
    webBrandCard: {
        minHeight: 96,
        justifyContent: 'center' as const,
    },
    webBrandCardBody: {
        flexWrap: 'nowrap' as const,
    },
    webBrandInfo: {
        width: undefined,
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 'auto' as const,
    },
    /** Android line-box correction; on web it just prints the name high. */
    webBrandName: {
        top: 0,
    },
    keyBoardView: {
        backgroundColor: appColors.light,
        alignContent: 'center',
        borderColor: appColors.light
    },
    containerView: {
        backgroundColor: appColors.lightBackgroundColor, borderColor: appColors.light
    },
    createBrandView: {
        flexDirection: "row", justifyContent: "space-between", height: 30, marginHorizontal: 20
    },
    createBrandStyle: {
        alignItems: 'flex-start', fontSize: fontSize.largerFontSize, fontFamily: appFonts.bold, color: appColors.lightDark
    },
    buttonContainerStyle: {
        marginHorizontal: 5,
        marginTop: 13
    },
    buttonTitleStyle: {
        fontSize: fontSize.mediumFontSize,
        fontFamily: appFonts.bold
    },
    iconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 6,
        borderColor: appColors.lightGrey,
        marginHorizontal: 5
    },
    iconTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallHeaderFontSize
    },
    iconStyle: {
        color: appColors.grey,
        paddingRight: 5
    },
    sortView: {
        marginVertical: 10, marginHorizontal: 8, width: 230
    },
    sortOptions: {
        fontSize: fontSize.smallFontSize,
        paddingHorizontal: 15,
        paddingVertical: 13
    },
    cardContainer: {
        flex: 1,
        borderRadius: 8,
        marginBottom: 5
    },
    nameViewStyle: {
        paddingHorizontal: 10,
        flex: 0.9,
    },
    badgeStyle: {
        backgroundColor: '#ffedbd',
    },
    textStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize,
        color: appColors.lightDark,
    },
    containerStyle: {
        justifyContent: 'center',
        alignSelf: 'flex-start',
        marginVertical: 15
    },
    actionViewStyle: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignSelf: 'center',
        flex: 0.15
    },
    priceView: {
        justifyContent: 'center',
        alignSelf: 'flex-end',
        margin: 10
    },
    actionView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'center',
        flex: 0.15,
    },
    iconBorderStyle: {
        borderWidth: 1,
        borderRadius: 11,
        width: 40,
        height: 40,
        margin: 3,
        padding: 3,
        borderColor: appColors.light,
        backgroundColor: appColors.lightBackgroundColor
    },
    filterHeaderStyle: { flexDirection: 'row', marginVertical: 5, justifyContent: 'flex-end' },
    filterContainer: { marginVertical: 10, marginHorizontal: 15, borderRadius: 16 },
    textStyle1: {
        fontSize: fontSize.smallFontSize, fontFamily: appFonts.bold, paddingHorizontal: 5,
    },
    filterFooterStyle: {
        flexDirection: 'row', marginVertical: 5, marginHorizontal: 10, justifyContent: "space-between", alignSelf: 'flex-end', zIndex: -1
    },
    titleStyle: { color: appColors.primary, fontFamily: appFonts.bold, fontSize: fontSize.mediumFontSize },
    listContainer: {
        flexDirection: 'row', flex: 1,
        borderRadius: 8,
        marginHorizontal: 20,
        marginVertical: 10,
        padding: 20,
        backgroundColor: appColors.light
    }

})